<template>
  <div class="tips" @click.stop v-if="data">
    <div class="title">还未完成签到哦！</div>
    <div class="desc-c">
      <div class="desc-line"></div>
      <div class="desc-dot"></div>
      <div class="desc-text">完成今日签到，可获得</div>
      <div class="desc-dot"></div>
      <div class="desc-line desc-line-after"></div>
    </div>
    <div class="prize-list">
      <div
        class="prize-item"
        :class="{ 'prize-item-three': todayPrizeList.length == 3 }"
        v-for="(item, index) in todayPrizeList"
        :key="index"
      >
        <div class="item-name">{{ item.win_goods_name }}</div>
        <div class="item-b">
          <img class="item-icon" :src="item.win_icon" alt="" />
          <div class="item-num">x{{ item.reward_num }}</div>
        </div>
      </div>
    </div>
    <div class="btn-confirm" @click="bindConfirm">立即签到</div>
    <div class="btn-cancel" @click="bindCancel">残忍放弃</div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    todayPrizeList() {
      let index = this.data.continuous_day
      return (
        (this.data.sign_task[index] && this.data.sign_task[index].goods_list) ||
        []
      )
    }
  },
  methods: {
    bindConfirm() {
      this.$emit('confirm')
    },
    bindCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.tips {
  width: 272px;
  padding: 30px 16px 20px;
  border-radius: 20px;
  background: linear-gradient(360deg, #ffffff 0%, #fee8db 100%);
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #8b3716;
    line-height: 28px;
    margin-bottom: 16px;
  }

  .desc-c {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;

    .desc-line {
      width: 33px;
      height: 1px;
      opacity: 0.5;
      background: linear-gradient(
        63deg,
        rgba(162, 90, 64, 0),
        rgba(162, 90, 64, 0.5)
      );
      margin-right: 5px;
    }

    .desc-line-after {
      background: linear-gradient(
        63deg,
        rgba(162, 90, 64, 0.5),
        rgba(162, 90, 64, 0)
      );
      margin-right: 0;
      margin-left: 5px;
    }

    .desc-dot {
      width: 2px;
      height: 2px;
      border-radius: 1px;
      background: rgba(209, 161, 148, 0.5);
    }

    .desc-text {
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: rgba(139, 55, 22, 0.8);
      line-height: 20px;
      margin: 0 9px;
    }
  }

  .prize-list {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .prize-item {
      width: 96px;
      height: 106px;
      background: #ffffff;
      box-shadow: 0px 2px 5px 0px rgba(253, 54, 69, 0.12);
      border-radius: 8px;
      margin-right: 6px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: stretch;

      .item-name {
        text-align: center;
        height: 22px;
        background: linear-gradient(270deg, #ff4078 0%, #ff634c 100%);
        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 22px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .item-b {
        padding-top: 7px;
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        .item-icon {
          width: 48px;
          height: 48px;
          object-fit: contain;
        }

        .item-num {
          font-size: 13px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #ff4444;
          line-height: 12px;
          text-align: center;
        }
      }
    }
    .prize-item-three {
      width: 76px;
    }
    .prize-item:last-child {
      margin-right: 0;
    }
  }

  .btn-confirm {
    text-align: center;
    margin: 0 auto;
    width: 178px;
    height: 44px;
    background: linear-gradient(180deg, #ff7e34 0%, #ff3b6d 100%);
    box-shadow: 0px 5px 12px 0px rgba(253, 54, 69, 0.3),
      inset 0px -6px 7px 0px #ff6985;
    border-radius: 26px;
    border: 1px solid;
    border-image: linear-gradient(
        180deg,
        rgba(255, 245, 202, 0),
        rgba(255, 247, 215, 0.6)
      )
      1 1;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 44px;
    margin-bottom: 16px;
  }

  .btn-cancel {
    width: 56px;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 16px;
  }
}
</style>
